import { render, staticRenderFns } from "./AccordionForSendMail.vue?vue&type=template&id=20c2d38a&"
import script from "./AccordionForSendMail.vue?vue&type=script&lang=js&"
export * from "./AccordionForSendMail.vue?vue&type=script&lang=js&"
import style0 from "./AccordionForSendMail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports